export const FETCH_SEASON_PERFORMANCE = "FETCH_SEASON_PERFORMANCE";
export const FETCH_SEASON_PERFORMANCE_PENDING = "FETCH_SEASON_PERFORMANCE_PENDING";
export const FETCH_SEASON_PERFORMANCE_REJECTED = "FETCH_SEASON_PERFORMANCE_REJECTED";
export const FETCH_SEASON_PERFORMANCE_FULFILLED = "FETCH_SEASON_PERFORMANCE_FULFILLED";
